import {addEffect} from 'ad-hok'

const addEffectOnMount = callback => addEffect(callback, [])

export default addEffectOnMount
